const defaultLensIconPairings = {
  blue: [
    'blue',
    'silver',
    'black',
    'white'
  ],
  brown: [
    'gold',
    'silver',
    'rose gold',
    'black'
  ],
  chrome: [
    'silver',
    'gunmetal',
    'white',
    'black'
  ],
  chrome4: [
    'silver',
    'gunmetal',
    'white',
    'black'
  ],
  clear: [
    'white',
    'black',
    'gold',
    'silver'
  ],
  fire: [
    'gold',
    'silver',
    'red',
    'black'
  ],
  gold: [
    'gold',
    'black',
    'white',
    'silver'
  ],
  green: [
    'green',
    'silver',
    'black',
    'blue'
  ],
  grn: [
    'green',
    'silver',
    'black',
    'blue'
  ],
  hvblue: [
    'gold',
    'white',
    'silver',
    'blue'
  ],
  IRhvblue: [
    'white',
    'silver',
    'blue',
    'gold'
  ],
  IRsmoke: [
    'gold',
    'black',
    'gunmetal',
    'silver'
  ],
  pink: [
    'silver',
    'white',
    'blue',
    'gold'
  ],
  purple: [
    'purple',
    'silver',
    'white',
    'gold'
  ],
  red: [
    'red',
    'silver',
    'black',
    'white'
  ],
  rose: [
    'rosegold',
    'silver',
    'gold',
    'white'
  ],
  silverblue: [
    'blue',
    'silver',
    'white',
    'black'
  ],
  water: [
    'blue',
    'silver',
    'white',
    'black'
  ],
  smoke: [
    'black',
    'silver',
    'gold',
    'blue'
  ]
}

export default defaultLensIconPairings

export function getLensIconPairings () {
  return defaultLensIconPairings
}